import React, { FC } from 'react';
import PropTypes from 'prop-types';
import logo from '../assets/logos/logo.jpeg';

interface ILogoProps {
	width?: number;
	height?: number;
}
const Logo: FC<ILogoProps> = ({ width, height }) => {
	return (
		<img
			width={width}
			height={height}
			src={logo}
			style={{
				objectFit: 'cover',
				borderRadius: '16px',
				boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
				border: '2px solid rgba(255, 255, 255, 0.1)',
				transition: 'all 0.3s ease',
			}}
			className="logo-modern"
		/>
	);
};
Logo.propTypes = {
	width: PropTypes.number,
	height: PropTypes.number,
};
Logo.defaultProps = {
	width: 2155,
	height: 854,
};

export default Logo;
